<template>
  <div id="EmergencyInvoice" style="display: none">
    <div
      class="invoice-container"
      style="
        padding: 10px;
        font-family: Arial, sans-serif;
        width: 100%;
        max-width: none;
      "
    >
      <!-- Header -->
      <div
        class="invoice-header"
        style="
          text-align: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #333;
          padding-bottom: 20px;
        "
      >
        <h1 style="margin: 0; color: #333">
          {{ $t("emergency.emergency-invoice") }}
        </h1>
        <p style="margin: 5px 0; color: #666">{{ $brand.nameEn }}</p>
        <p style="margin: 5px 0; color: #666">
          {{ $t("common.invoice-no") }}: #{{
            getNestedProperty(data, "invoice_no")
          }}
        </p>
        <p style="margin: 5px 0; color: #666">
          {{ $t("common.date") }}:
          {{ formatDate(getNestedProperty(data, "created_at")) }}
        </p>
      </div>

      <!-- Patient Information -->
      <div
        class="patient-info"
        style="
          margin-bottom: 30px;
          padding: 15px;
          background-color: #f8f9fa;
          border-radius: 5px;
        "
      >
        <h3
          style="
            margin: 0 0 15px 0;
            color: #333;
            border-bottom: 1px solid #dee2e6;
            padding-bottom: 10px;
          "
        >
          {{ $t("common.patient_information") }}
        </h3>
        <table style="width: 100%; border-collapse: collapse">
          <tr>
            <td style="padding: 8px; width: 25%; font-weight: bold">
              {{ $t("common.name") }}:
            </td>
            <td style="padding: 8px; width: 25%">
              {{ getPatientName() }}
            </td>
            <td style="padding: 8px; width: 25%; font-weight: bold">
              {{ $t("reception.gender") }}:
            </td>
            <td style="padding: 8px; width: 25%">
              {{ getPatientGender() }}
            </td>
          </tr>
          <tr>
            <td style="padding: 8px; font-weight: bold">
              {{ $t("reception.birth-date") }}:
            </td>
            <td style="padding: 8px">
              {{ getPatientBirthDate() }}
            </td>
            <td style="padding: 8px; font-weight: bold">
              {{ $t("reception.phone") }}:
            </td>
            <td style="padding: 8px">
              {{ getPatientPhone() }}
            </td>
          </tr>
        </table>
      </div>

      <!-- Service Details Table -->
      <div class="service-details" style="margin-bottom: 30px">
        <h3
          style="
            margin: 0 0 15px 0;
            color: #333;
            border-bottom: 1px solid #dee2e6;
            padding-bottom: 10px;
          "
        >
          {{ $t("emergency.service-details") }}
        </h3>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dee2e6;
            table-layout: fixed;
          "
        >
          <thead>
            <tr style="background-color: #f8f9fa">
              <th
                style="
                  padding: 8px;
                  text-align: left;
                  border: 1px solid #dee2e6;
                  width: 10%;
                "
              >
                {{ $t("common.no") }}
              </th>
              <th
                style="
                  padding: 8px;
                  text-align: left;
                  border: 1px solid #dee2e6;
                  width: 60%;
                "
              >
                {{ $t("reception.service") }}
              </th>
              <th
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                  width: 30%;
                "
              >
                {{ $t("employee.amount") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getInvoiceItems()" :key="index">
              <td style="padding: 8px; border: 1px solid #dee2e6">
                {{ index + 1 }}
              </td>
              <td style="padding: 8px; border: 1px solid #dee2e6">
                {{ getNestedProperty(item, "name", "N/A") }}
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                  font-weight: bold;
                "
              >
                {{ formatPrice(getNestedProperty(item, "net_amount", 0)) }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr style="background-color: #f8f9fa">
              <td
                colspan="2"
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                  font-weight: bold;
                "
              >
                {{ $t("common.subtotal") }}:
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                  font-weight: bold;
                "
              >
                {{ formatPrice(getNestedProperty(data, "amount", 0)) }}
              </td>
            </tr>
            <tr
              v-if="getNestedProperty(data, 'discount', 0) > 0"
              style="background-color: #fff3cd"
            >
              <td
                colspan="2"
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                  font-weight: bold;
                  color: #856404;
                "
              >
                {{ $t("common.discount") }}:
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                  font-weight: bold;
                  color: #856404;
                "
              >
                - {{ formatPrice(getNestedProperty(data, "discount", 0)) }}
              </td>
            </tr>
            <tr style="background-color: #d4edda; font-weight: bold">
              <td
                colspan="2"
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                "
              >
                {{ $t("common.total") }}:
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: right;
                  border: 1px solid #dee2e6;
                  font-size: 1.2em;
                  color: #155724;
                "
              >
                {{ formatPrice(calculateTotal()) }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Footer -->
      <div
        class="invoice-footer"
        style="
          margin-top: 50px;
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid #dee2e6;
          color: #666;
          font-size: 0.9em;
        "
      >
        <p style="margin: 5px 0">
          {{ $t("common.thank-you") }}
        </p>
        <p style="margin: 5px 0">
          {{ $t("common.printed-on") }}: {{ getCurrentDate() }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getNestedProperty } from "@/utils/nestedProperty.js";

export default {
  props: {
    patientData: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    getNestedProperty,

    getInvoiceItems() {
      return getNestedProperty(this.data, "invoice_items", []);
    },

    formatPrice(price) {
      return price ? `${Number(price).toLocaleString()} IQD` : "0 IQD";
    },

    calculateTotal() {
      const amount = parseFloat(getNestedProperty(this.data, "amount", 0)) || 0;
      const discount =
        parseFloat(getNestedProperty(this.data, "discount", 0)) || 0;
      return amount - discount;
    },

    // Get patient information safely
    getPatientName() {
      return (
        getNestedProperty(this.data, "patient_card.patient.name") ||
        getNestedProperty(this.patientData, "name", "N/A")
      );
    },

    getPatientGender() {
      return (
        getNestedProperty(this.data, "patient_card.patient.gender") ||
        getNestedProperty(this.patientData, "gender", "N/A")
      );
    },

    getPatientBirthDate() {
      return (
        getNestedProperty(this.data, "patient_card.patient.birth_date") ||
        getNestedProperty(this.patientData, "birth_date", "N/A")
      );
    },

    getPatientPhone() {
      return (
        getNestedProperty(this.data, "patient_card.patient.phone") ||
        getNestedProperty(this.patientData, "phone", "N/A")
      );
    },

    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    getCurrentDate() {
      return new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
@media print {
  #EmergencyInvoice {
    display: block !important;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .invoice-container {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 5px !important;
  }

  table {
    width: 100% !important;
    font-size: 12px !important;
  }

  th,
  td {
    padding: 6px !important;
    font-size: 12px !important;
  }
}
</style>
